<template>
  <section class="section-container objectives-bg">
    <h2 class="section-title">{{ $t('home-page.objectives.title') }}</h2>
    <p class="section-subtitle">{{ $t('home-page.objectives.desc') }}</p>

    <div class="objectives-grid">
      <div class="objective-card" data-aos="fade-up">
        <img src="@/assets/reduceAccidents.jpg" alt="Reduce Accidents">
        <div class="card-content">
          <h3>{{ $t('home-page.objectives.objective[0]') }}</h3>
        </div>
      </div>
      <div class="objective-card" data-aos="fade-up" data-aos-delay="100">
        <img src="@/assets/improve-safety.jpg" alt="Improve Safety">
        <div class="card-content">
          <h3>{{ $t('home-page.objectives.objective[1]') }}</h3>
        </div>
      </div>
      <div class="objective-card" data-aos="fade-up" data-aos-delay="200">
        <img src="@/assets/developHummanCapital.jpg" alt="Develop Human Capital">
        <div class="card-content">
          <h3>{{ $t('home-page.objectives.objective[2]') }}</h3>
        </div>
      </div>
      <div class="objective-card" data-aos="fade-up" data-aos-delay="300">
        <img src="@/assets/grow-business.jpg" alt="Grow Business">
        <div class="card-content">
          <h3>{{ $t('home-page.objectives.objective[3]') }}</h3>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.objectives-bg {
  background-color: #f8f9fa;
}

.objectives-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.objective-card {
  background-color: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
}

.objective-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.objective-card img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  display: block;
}

.card-content {
  padding: 1.5rem;
  text-align: center;
}

.card-content h3 {
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
  margin: 0;
}

@media (max-width: 768px) {
  .objectives-grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 576px) {
  .objectives-grid {
    grid-template-columns: 1fr;
  }
  .objective-card img {
    height: 180px;
  }
}
</style>

